import { observer } from 'mobx-react-lite';

import { FullCompose } from 'owa-mail-compose-view';
import { messageAdListViewStatusStore } from 'owa-mail-messagead-list-store';
import { MessageAdReadingPane } from 'owa-mail-messagead-readingpane-view';
import { ReadingPane } from 'owa-mail-reading-pane-view';
import { getActiveContentTab, TabType, TabViewState } from 'owa-tab-store';
import * as React from 'react';

import { composeStore } from 'owa-mail-compose-store';

export interface ReadingPaneContainerProps {
    isDumpsterOrDumpsterSearchTable?: boolean;
    suppressServerMarkReadOnReplyOrForward?: boolean;
    isNotesFolder?: boolean;
}

const styles = require('./ReadingPaneContainer.scss');
export default observer(function ReadingPaneContainer(props: ReadingPaneContainerProps) {
    const renderReadingPane = (): JSX.Element => {
        let renderContent = null;
        const activeTab = getActiveContentTab();
        // If in dumpster or dumpster search, should always show reading pane (no compose)
        if (props.isDumpsterOrDumpsterSearchTable) {
            renderContent = (
                <ReadingPane
                    isDumpsterOrDumpsterSearchTable={props.isDumpsterOrDumpsterSearchTable}
                    isNotesFolder={props.isNotesFolder}
                />
            );
        } else {
            // Priority for content to be loaded into the Reading Pane:
            // 1. If a message ad has been clicked.
            // 2. If we're in tab view and have an activate tab matching these types.
            // 3. If a full compose is open.
            // 4. Render the base reading pane out of the store.
            if (messageAdListViewStatusStore.selectedAdId) {
                renderContent = (
                    <MessageAdReadingPane
                        selectedAdRowId={messageAdListViewStatusStore.selectedAdId}
                    />
                );
            } else if (
                activeTab &&
                (activeTab.type == TabType.Compose ||
                    activeTab.type == TabType.SecondaryReadingPane)
            ) {
                // TODO: render all types of tab using this.renderTabContent()
                renderContent = renderTabContent(activeTab);
            } else if (
                composeStore.primaryComposeId &&
                !composeStore.viewStates.get(composeStore.primaryComposeId).isInlineCompose
            ) {
                renderContent = (
                    <FullCompose
                        viewState={composeStore.viewStates.get(composeStore.primaryComposeId)}
                    />
                );
            } else {
                renderContent = (
                    <ReadingPane
                        isDumpsterOrDumpsterSearchTable={props.isDumpsterOrDumpsterSearchTable}
                        isNotesFolder={props.isNotesFolder}
                    />
                );
            }
        }
        return <div key="renderReadingPaneDiv">{renderContent}</div>;
    };
    const renderTabContent = (tab: TabViewState) => {
        let content: JSX.Element = null;
        switch (tab.type) {
            case TabType.Compose:
                const composeViewState = composeStore.viewStates.get(tab.data);
                content = (
                    <FullCompose key={composeViewState.composeId} viewState={composeViewState} />
                );
                break;
            case TabType.SecondaryReadingPane:
                content = (
                    <ReadingPane
                        isDumpsterOrDumpsterSearchTable={props.isDumpsterOrDumpsterSearchTable}
                        isNotesFolder={props.isNotesFolder}
                    />
                );
                break;
        }
        return content;
    };
    return (
        <div className={styles.showTabBar} key="readingPaneContainerDiv">
            {renderReadingPane()}
        </div>
    );
});
